module.exports = __webpack_public_path__ + "img/colombia.19a1baa4.png";